module.exports = __webpack_public_path__ + "img/projects2.e32c318b.png";